import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Table
} from 'reactstrap';
import $ from 'jquery';
import ManagePage from '../../views/ManagePage/';
import ManageStaffPage from '../../views/ManageStaffPage/';

class GroupSummary extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			posts : [],
			_redirect : false,
			_redirectView : false
		}
	}
	componentDidMount() {
		 
		this.getdata();
	}
	
	getdata(){
		$("#showLoader").show();	
		GetData('group/getgroupmembers').then((result) => {
			$("#showLoader").hide();	
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	onAddClick(id){

		this.setState({gid : id,_redirect : true});
	}

	onViewClick(id){

		this.setState({gid : id,_redirectView : true});
	}

  render() {
	
	if(this.state._redirect){
		return (<Redirect to={'/group/members/'+this.state.gid} />);
	}
	if(this.state._redirectView){
		return (<Redirect to={'/group/listmember/'+this.state.gid} />);
	}

    return (
		<div>
		  {sessionStorage.getItem('userrole') == 'staff' ?
			<ManageStaffPage /> : <ManagePage /> }
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
				<Row>
				  <Col md="12">
				   <Card>
					<CardHeader>
						<strong>Group Details</strong>
					</CardHeader>
					<CardBody>
					<Table responsive bordered>
						<thead>
							<tr>
								<th>S.No</th>
								<th>Group Name</th>
								<th>Type</th>
								<th>Total Members</th>
								<th width="100">Manage</th>
							</tr>
						</thead>
						<tbody>
						  {this.state.posts.map((item,index) =>
							<tr key = {item}>
								<td>{index+1}</td>
								<td>{item.groupname}</td>
								<td>{item.type}</td>
								<td>{item.pcount}</td>
								<td>
									<button className="btn btn-primary btn-sm" onClick={() => this.onAddClick(item.groupid)} ><i className="fa fa-plus"></i></button>&nbsp;&nbsp;
									<button className="btn btn-warning btn-sm" onClick={() => this.onViewClick(item.groupid)} ><i className="fa fa-eye"></i></button>&nbsp;&nbsp;
									<button className="btn btn-danger btn-sm" onClick={() => this.onViewClick(item.groupid)} ><i className="fa fa-remove"></i></button>
								</td>
							</tr>
						  )}
						</tbody>
					</Table>
					</CardBody>
				   </Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default GroupSummary;


// WEBPACK FOOTER //
// ./src/group/AddGroupMember/GroupSummary.js